import { presetGpnDark, presetGpnDefault, } from "@consta/uikit/Theme";
export var ThemeType;
(function (ThemeType) {
    ThemeType["DARK"] = "dark";
    ThemeType["LIGTH"] = "ligth";
})(ThemeType || (ThemeType = {}));
var THEME_KEY = "theme";
var createThemeSlice = function (set, get, _api) { return ({
    selectedTheme: getThemeFromStorage(),
    switchTheme: function () {
        if (get().selectedTheme === presetGpnDefault) {
            set(function () { return ({ selectedTheme: presetGpnDark }); });
            localStorage.setItem(THEME_KEY, ThemeType.DARK);
        }
        else {
            set(function () { return ({ selectedTheme: presetGpnDefault }); });
            localStorage.setItem(THEME_KEY, ThemeType.LIGTH);
        }
    },
}); };
export default createThemeSlice;
var getThemeFromStorage = function () {
    if (!localStorage.getItem(THEME_KEY)) {
        localStorage.setItem(THEME_KEY, ThemeType.LIGTH);
        return presetGpnDefault;
    }
    if (localStorage.getItem(THEME_KEY) === ThemeType.LIGTH)
        return presetGpnDefault;
    return presetGpnDark;
};
